package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Zambia Flag (16x12dp)
 *
 * - ISO Alpha-2: ZM
 * - ISO Alpha-3: ZMB
 * - ISO Numeric: 894
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Zambia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Zambia:ZM:ZMB:894:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFF8126))) {
                moveTo(13f, 5f)
                horizontalLineToRelative(3f)
                verticalLineToRelative(7f)
                horizontalLineToRelative(-3f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(10f, 5f)
                horizontalLineToRelative(3f)
                verticalLineToRelative(7f)
                horizontalLineToRelative(-3f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(7f, 5f)
                horizontalLineToRelative(3f)
                verticalLineToRelative(7f)
                horizontalLineToRelative(-3f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF8126)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.808f, 1.558f)
                curveTo(11.078f, 1.658f, 10.808f, 1.81f, 10.808f, 1.81f)
                curveTo(10.808f, 1.81f, 10.754f, 1.748f, 10.754f, 1.696f)
                curveTo(10.754f, 1.644f, 10.547f, 1.696f, 10.44f, 1.885f)
                curveTo(10.339f, 2.063f, 10.525f, 2.062f, 10.722f, 2.062f)
                curveTo(10.733f, 2.062f, 10.743f, 2.062f, 10.754f, 2.062f)
                curveTo(10.865f, 2.062f, 11.039f, 2.051f, 11.2f, 2.041f)
                curveTo(11.34f, 2.032f, 11.471f, 2.024f, 11.544f, 2.024f)
                curveTo(11.701f, 2.024f, 11.775f, 2.024f, 11.982f, 1.885f)
                curveTo(12.116f, 1.794f, 12.56f, 1.683f, 12.891f, 1.601f)
                curveTo(13.069f, 1.557f, 13.213f, 1.521f, 13.259f, 1.501f)
                curveTo(13.389f, 1.443f, 13.129f, 1.748f, 13.129f, 1.748f)
                curveTo(13.129f, 1.748f, 14.135f, 1.342f, 14.336f, 1.204f)
                curveTo(14.461f, 1.118f, 14.404f, 1.191f, 14.312f, 1.311f)
                curveTo(14.255f, 1.384f, 14.185f, 1.476f, 14.135f, 1.558f)
                curveTo(14.05f, 1.699f, 14.223f, 1.565f, 14.415f, 1.416f)
                curveTo(14.518f, 1.336f, 14.627f, 1.252f, 14.704f, 1.204f)
                curveTo(14.926f, 1.065f, 14.648f, 1.441f, 14.526f, 1.558f)
                curveTo(14.403f, 1.676f, 14.813f, 1.558f, 14.954f, 1.441f)
                curveTo(15.058f, 1.355f, 14.963f, 1.506f, 14.883f, 1.633f)
                curveTo(14.854f, 1.678f, 14.828f, 1.721f, 14.813f, 1.748f)
                lineTo(14.81f, 1.753f)
                curveTo(14.755f, 1.853f, 14.738f, 1.885f, 14.869f, 1.885f)
                curveTo(15.002f, 1.885f, 14.526f, 2.255f, 14.526f, 2.255f)
                curveTo(14.526f, 2.255f, 14.668f, 2.233f, 14.526f, 2.479f)
                curveTo(14.442f, 2.625f, 14.034f, 2.772f, 13.703f, 2.891f)
                curveTo(13.473f, 2.974f, 13.28f, 3.044f, 13.259f, 3.09f)
                curveTo(13.222f, 3.173f, 12.851f, 3.27f, 12.677f, 3.315f)
                curveTo(12.616f, 3.331f, 12.579f, 3.34f, 12.592f, 3.34f)
                curveTo(12.641f, 3.34f, 12.722f, 3.402f, 12.634f, 3.402f)
                curveTo(12.546f, 3.402f, 12.391f, 3.452f, 12.391f, 3.452f)
                curveTo(12.391f, 3.452f, 12.473f, 3.452f, 12.391f, 3.568f)
                curveTo(12.352f, 3.624f, 12.284f, 3.615f, 12.236f, 3.609f)
                curveTo(12.184f, 3.602f, 12.156f, 3.598f, 12.216f, 3.684f)
                curveTo(12.27f, 3.761f, 12.29f, 3.79f, 12.284f, 3.798f)
                curveTo(12.276f, 3.807f, 12.236f, 3.791f, 12.173f, 3.791f)
                curveTo(12.117f, 3.791f, 12.057f, 3.767f, 11.994f, 3.742f)
                curveTo(11.924f, 3.714f, 11.851f, 3.684f, 11.775f, 3.684f)
                curveTo(11.637f, 3.684f, 11.776f, 3.782f, 11.863f, 3.844f)
                curveTo(11.866f, 3.846f, 11.87f, 3.849f, 11.873f, 3.851f)
                curveTo(11.951f, 3.906f, 11.918f, 3.906f, 11.778f, 3.905f)
                curveTo(11.764f, 3.905f, 11.748f, 3.905f, 11.732f, 3.905f)
                curveTo(11.645f, 3.905f, 11.598f, 3.896f, 11.573f, 3.891f)
                curveTo(11.547f, 3.885f, 11.544f, 3.885f, 11.544f, 3.905f)
                curveTo(11.544f, 3.925f, 11.479f, 3.898f, 11.4f, 3.865f)
                curveTo(11.318f, 3.831f, 11.222f, 3.791f, 11.17f, 3.791f)
                curveTo(11.067f, 3.791f, 11.388f, 4.003f, 11.388f, 4.003f)
                curveTo(11.388f, 4.003f, 11.22f, 3.949f, 11.13f, 3.905f)
                curveTo(11.078f, 3.881f, 11.144f, 3.997f, 11.203f, 4.103f)
                curveTo(11.248f, 4.183f, 11.289f, 4.257f, 11.272f, 4.257f)
                curveTo(11.26f, 4.257f, 11.232f, 4.243f, 11.201f, 4.228f)
                curveTo(11.137f, 4.197f, 11.056f, 4.159f, 11.056f, 4.21f)
                curveTo(11.056f, 4.288f, 11.13f, 4.345f, 11.22f, 4.345f)
                curveTo(11.311f, 4.345f, 11.326f, 4.465f, 11.272f, 4.465f)
                curveTo(11.254f, 4.465f, 11.231f, 4.457f, 11.209f, 4.45f)
                curveTo(11.168f, 4.435f, 11.13f, 4.422f, 11.13f, 4.465f)
                curveTo(11.13f, 4.493f, 11.146f, 4.514f, 11.165f, 4.538f)
                curveTo(11.19f, 4.572f, 11.22f, 4.611f, 11.22f, 4.683f)
                curveTo(11.22f, 4.808f, 11.086f, 4.826f, 11.13f, 4.743f)
                curveTo(11.174f, 4.66f, 10.977f, 4.46f, 10.977f, 4.558f)
                verticalLineTo(4.683f)
                curveTo(10.977f, 4.772f, 10.96f, 4.777f, 10.933f, 4.786f)
                curveTo(10.917f, 4.791f, 10.897f, 4.798f, 10.875f, 4.826f)
                curveTo(10.842f, 4.868f, 10.837f, 4.891f, 10.834f, 4.905f)
                curveTo(10.832f, 4.918f, 10.831f, 4.921f, 10.808f, 4.921f)
                curveTo(10.789f, 4.921f, 10.774f, 4.893f, 10.753f, 4.856f)
                curveTo(10.721f, 4.799f, 10.677f, 4.72f, 10.59f, 4.683f)
                curveTo(10.507f, 4.649f, 10.502f, 4.674f, 10.495f, 4.717f)
                curveTo(10.489f, 4.749f, 10.482f, 4.791f, 10.44f, 4.826f)
                curveTo(10.377f, 4.879f, 10.394f, 4.901f, 10.415f, 4.927f)
                curveTo(10.427f, 4.942f, 10.44f, 4.958f, 10.44f, 4.982f)
                curveTo(10.44f, 5.048f, 10.33f, 4.916f, 10.33f, 4.826f)
                curveTo(10.33f, 4.736f, 10.204f, 4.617f, 10.204f, 4.683f)
                curveTo(10.204f, 4.75f, 10.204f, 4.826f, 10.14f, 4.826f)
                curveTo(10.109f, 4.826f, 10.108f, 4.848f, 10.106f, 4.878f)
                curveTo(10.104f, 4.91f, 10.102f, 4.951f, 10.062f, 4.982f)
                curveTo(10.022f, 5.013f, 10.023f, 4.997f, 10.025f, 4.96f)
                curveTo(10.027f, 4.925f, 10.029f, 4.873f, 9.998f, 4.826f)
                curveTo(9.96f, 4.768f, 9.992f, 4.677f, 10.009f, 4.631f)
                curveTo(10.019f, 4.602f, 10.023f, 4.591f, 9.998f, 4.617f)
                curveTo(9.936f, 4.683f, 9.856f, 4.683f, 9.802f, 4.683f)
                lineTo(9.8f, 4.683f)
                curveTo(9.773f, 4.683f, 9.749f, 4.718f, 9.732f, 4.742f)
                curveTo(9.715f, 4.767f, 9.705f, 4.781f, 9.705f, 4.743f)
                curveTo(9.705f, 4.667f, 9.785f, 4.465f, 9.936f, 4.465f)
                curveTo(10.052f, 4.465f, 10.11f, 4.418f, 10.16f, 4.378f)
                curveTo(10.175f, 4.366f, 10.189f, 4.354f, 10.204f, 4.345f)
                curveTo(10.269f, 4.304f, 10.204f, 4.25f, 10.14f, 4.21f)
                curveTo(10.111f, 4.192f, 10.121f, 4.135f, 10.142f, 4.083f)
                curveTo(10.177f, 4.06f, 10.204f, 4.031f, 10.204f, 4.003f)
                curveTo(10.204f, 3.967f, 10.166f, 4.021f, 10.142f, 4.083f)
                curveTo(10.095f, 4.113f, 10.034f, 4.133f, 9.998f, 4.133f)
                curveTo(9.964f, 4.133f, 9.986f, 4.071f, 10.012f, 3.993f)
                curveTo(10.035f, 3.928f, 10.062f, 3.851f, 10.062f, 3.791f)
                curveTo(10.062f, 3.734f, 10.071f, 3.684f, 10.078f, 3.65f)
                curveTo(10.086f, 3.605f, 10.09f, 3.587f, 10.062f, 3.61f)
                curveTo(10.027f, 3.64f, 9.84f, 3.607f, 9.713f, 3.585f)
                curveTo(9.659f, 3.576f, 9.615f, 3.568f, 9.599f, 3.568f)
                curveTo(9.576f, 3.568f, 9.595f, 3.524f, 9.614f, 3.479f)
                curveTo(9.638f, 3.423f, 9.661f, 3.368f, 9.599f, 3.402f)
                curveTo(9.502f, 3.456f, 9.304f, 3.454f, 9.179f, 3.453f)
                curveTo(9.161f, 3.452f, 9.144f, 3.452f, 9.129f, 3.452f)
                curveTo(9.056f, 3.452f, 9.106f, 3.388f, 9.133f, 3.353f)
                curveTo(9.149f, 3.333f, 9.157f, 3.323f, 9.129f, 3.34f)
                curveTo(9.055f, 3.388f, 8.98f, 3.402f, 8.896f, 3.402f)
                curveTo(8.859f, 3.402f, 8.848f, 3.38f, 8.836f, 3.355f)
                curveTo(8.821f, 3.325f, 8.805f, 3.292f, 8.737f, 3.293f)
                curveTo(8.613f, 3.294f, 8.585f, 3.292f, 8.517f, 3.238f)
                curveTo(8.481f, 3.21f, 8.501f, 3.193f, 8.512f, 3.184f)
                curveTo(8.523f, 3.175f, 8.526f, 3.173f, 8.471f, 3.173f)
                horizontalLineTo(8.134f)
                curveTo(7.966f, 3.173f, 8.135f, 3.042f, 8.195f, 3.042f)
                curveTo(8.256f, 3.042f, 8.326f, 2.924f, 8.195f, 2.977f)
                curveTo(8.112f, 3.011f, 8.022f, 3.001f, 7.916f, 2.99f)
                curveTo(7.857f, 2.984f, 7.792f, 2.977f, 7.72f, 2.977f)
                curveTo(7.521f, 2.977f, 7.483f, 2.885f, 7.601f, 2.885f)
                curveTo(7.719f, 2.885f, 7.726f, 2.817f, 7.542f, 2.817f)
                curveTo(7.428f, 2.817f, 7.333f, 2.786f, 7.263f, 2.763f)
                curveTo(7.221f, 2.749f, 7.188f, 2.738f, 7.164f, 2.738f)
                curveTo(7.099f, 2.738f, 7.029f, 2.647f, 7.164f, 2.647f)
                curveTo(7.298f, 2.647f, 7.471f, 2.572f, 7.323f, 2.572f)
                curveTo(7.24f, 2.572f, 7.102f, 2.528f, 6.981f, 2.489f)
                curveTo(6.888f, 2.459f, 6.806f, 2.433f, 6.768f, 2.433f)
                curveTo(6.739f, 2.433f, 6.784f, 2.423f, 6.845f, 2.41f)
                curveTo(6.966f, 2.384f, 7.147f, 2.345f, 6.916f, 2.345f)
                curveTo(6.669f, 2.345f, 6.411f, 2.144f, 6.232f, 2.005f)
                curveTo(6.16f, 1.949f, 6.1f, 1.903f, 6.06f, 1.885f)
                curveTo(5.922f, 1.821f, 6.06f, 1.696f, 6.1f, 1.748f)
                curveTo(6.14f, 1.8f, 6.419f, 1.88f, 6.298f, 1.81f)
                curveTo(6.177f, 1.741f, 6.1f, 1.622f, 6.06f, 1.558f)
                curveTo(6.02f, 1.494f, 6.051f, 1.45f, 6.1f, 1.501f)
                curveTo(6.149f, 1.551f, 6.376f, 1.696f, 6.376f, 1.696f)
                curveTo(6.376f, 1.696f, 6.255f, 1.558f, 6.158f, 1.342f)
                curveTo(6.062f, 1.126f, 6.255f, 1.179f, 6.419f, 1.342f)
                curveTo(6.584f, 1.506f, 6.739f, 1.549f, 6.817f, 1.558f)
                curveTo(6.894f, 1.568f, 6.739f, 1.441f, 6.59f, 1.342f)
                curveTo(6.44f, 1.244f, 6.474f, 0.892f, 6.59f, 1.033f)
                curveTo(6.65f, 1.106f, 6.934f, 1.245f, 7.213f, 1.381f)
                curveTo(7.47f, 1.507f, 7.721f, 1.63f, 7.786f, 1.696f)
                curveTo(7.899f, 1.811f, 7.808f, 1.64f, 7.71f, 1.455f)
                curveTo(7.69f, 1.418f, 7.67f, 1.379f, 7.651f, 1.342f)
                curveTo(7.585f, 1.217f, 7.847f, 1.36f, 8.146f, 1.522f)
                curveTo(8.36f, 1.639f, 8.594f, 1.766f, 8.737f, 1.81f)
                curveTo(8.836f, 1.841f, 8.954f, 1.89f, 9.072f, 1.939f)
                curveTo(9.363f, 2.06f, 9.653f, 2.18f, 9.653f, 2.024f)
                curveTo(9.653f, 1.803f, 9.919f, 1.459f, 10.204f, 1.342f)
                curveTo(10.385f, 1.269f, 10.47f, 1.335f, 10.578f, 1.419f)
                curveTo(10.64f, 1.468f, 10.709f, 1.522f, 10.808f, 1.558f)
                close()
                moveTo(10.501f, 4.142f)
                curveTo(10.565f, 4.142f, 10.547f, 3.473f, 10.547f, 3.473f)
                curveTo(10.547f, 3.473f, 10.738f, 3.884f, 10.738f, 4.061f)
                curveTo(10.738f, 4.142f, 10.732f, 4.166f, 10.734f, 4.19f)
                curveTo(10.736f, 4.217f, 10.749f, 4.244f, 10.795f, 4.366f)
                curveTo(10.841f, 4.49f, 10.81f, 4.476f, 10.726f, 4.44f)
                curveTo(10.658f, 4.41f, 10.555f, 4.366f, 10.43f, 4.366f)
                curveTo(10.149f, 4.366f, 10.436f, 4.142f, 10.501f, 4.142f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun ZambiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Zambia,
            contentDescription = "Zambia Flag"
        )
    }
}
